import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-polyglot';
import MoodDepressedIcon from '../../assets/icons/mood-depressed.svg';
import MoodSadIcon from '../../assets/icons/mood-sad.svg';
import MoodOkayIcon from '../../assets/icons/mood-okay.svg';
import MoodHappyIcon from '../../assets/icons/mood-happy.svg';
import { 
  FormCheckbox,
  FormLabel,
  FormTextArea,
  FormRadio,
  BaseForm
} from '../form';
import IconChooser from '../form/FormIconChooser';
import HelpTooltip from '../edu/HelpTooltip';
import { Button } from '../buttons';
import './DiaryEntryForm.css';

function DiaryEntryForm(props) {
  const feelings = [
    { name: 'feeling', value: 'depressed', icon: MoodDepressedIcon },
    { name: 'feeling', value: 'sad', icon: MoodSadIcon },
    { name: 'feeling', value: 'okay', icon: MoodOkayIcon },
    { name: 'feeling', value: 'happy', icon: MoodHappyIcon }
  ];

  const { isNew, onSubmit, t, initialValues } = props;
  
  return (
    <BaseForm onSubmit={onSubmit} className="diary-entry-form">
      {isNew ? (
        <h2>{t('diaryEditor.createTitle')}</h2>
      ) : (
        <h2>{t('diaryEditor.editTitle')}</h2>
      )}
      <FormLabel center>{t('diaryEditor.feelingLabel')}</FormLabel>
      <IconChooser className="icon-chooser--small diary-entry-form__feeling-chooser">
        {feelings.map(feeling => (
          <FormRadio
            key={feeling.value}
            name={feeling.name}
            initialValue={isNew ? 'happy' : initialValues.feeling}
            value={feeling.value}
            imageSrc={feeling.icon}
            imageAlt={t(`diary.${feeling.value}`)}
            className={`diary-entry-form__feeling--${feeling.value}`}
          />
        ))}
      </IconChooser>

      <FormTextArea
        labelRenderer={() => (
          <FormLabel note={t('diaryEditor.optional')}>
            {t('diaryEditor.contentLabel')}
          </FormLabel>
        )}
        initialValue={isNew ? '' : initialValues.content}
        name="content"
        className="diary-entry-form__textarea"
      />
      <div className="form-footer-columns">
        <div className="form-footer-columns__left">
          <FormCheckbox 
            name="hidden"
            initialValue={isNew || initialValues.hidden}
          >
            {t('diaryEditor.hiddenLabel')}
          </FormCheckbox>
          <HelpTooltip html={t('diaryEditor.hiddenNote')} />
        </div>
        <div className="form-footer-columns__right">
          <Button label={t('diaryEditor.save')} />
        </div>
      </div>
    </BaseForm>
  );
}

DiaryEntryForm.propTypes = {
  isNew: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

export default translate()(DiaryEntryForm);



// WEBPACK FOOTER //
// ./src/components/diary/DiaryEntryForm.js